export const regex = {
  namestring: /^[A-Za-zÀ-ÿ0-9\s'-]{2,}$/,
  numberdata: /^\d{1,100}$/,
  teleregex: /^(034|033|032|037|039|038|037)\d{7}$/,
  // dateRegex: /^\d{4}-\d{2}-\d{2}$/
  dateRegex: /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/
};